import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  HStack,
  Spinner,
} from "@chakra-ui/react";
import { Controller } from "react-hook-form";

const FormController = ({
  label,
  rules,
  isDisabled = false,
  isLoadingInput = false,
  helperText = null,
  errors = null,
  showRequiredIcon = true,
  isReadOnly = false,
  children,
  ...props
}) => {
  const error = errors?.[props?.name];
  const isInvalid = error !== undefined;
  const isRequired = rules?.required;
  const isFormDisabled = isDisabled || isLoadingInput;

  return (
    <FormControl
      isInvalid={isInvalid}
      isRequired={isRequired}
      isReadOnly={isReadOnly}
      isDisabled={isFormDisabled}
    >
      <HStack>
        <FormLabel>{label}</FormLabel>
        {isLoadingInput && (
          <Spinner size="small" color="$primary.1000" ml={1} />
        )}
      </HStack>
      <Controller rules={rules} {...props} />

      {helperText != null && <FormHelperText>{helperText}</FormHelperText>}
      {isInvalid && (
        <FormErrorMessage>
          {error?.message ? error.message : "This field is invalid"}
        </FormErrorMessage>
      )}
    </FormControl>
  );
};

export default FormController;
